module.exports = __webpack_public_path__ + "img/500-bg-top-mobile.07241fb.webp";